<template>
  <div id="data-list-list-view" class="data-list-container">

    <vs-table :sst="true" ref="table" :max-items="itemsPerPage" search :data="orders" @search="handleSearch" >

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ADD NEW -->
          <!--<div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">-->
            <!--<feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />-->
              <!--<span class="ml-2 text-base text-primary">Add New</span>-->
          <!--</div>-->
          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="refreshTable">
            <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Refresh</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ itemsPerPage }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="itemsPerPage=5">
                <span>5</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=20">
                <span>20</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>

      <template slot="thead">
        <vs-th>Order</vs-th>
        <vs-th>Date</vs-th>
        <vs-th>Customer</vs-th>
        <vs-th>Payment</vs-th>
        <vs-th>Courier</vs-th>
        <vs-th>AWB</vs-th>
        <vs-th>Total</vs-th>
        <vs-th>Action</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.id }}</p>
              </vs-td>

              <vs-td>
                <p class="product-category">{{ formatDate(tr.create_at) }}</p>
              </vs-td>

              <vs-td>
                <p class="product-category">{{ tr.name }}</p>
              </vs-td>

              <vs-td>
                <p class="product-category"><vs-chip :color="getPaymentColor(tr.status)">{{ getPaymentStatus(tr.status) }}</vs-chip></p>
              </vs-td>

              <vs-td>
                <p class="product-category">{{ tr.courier_name }}</p>
              </vs-td>

              <vs-td>
                <p class="product-category"><router-link :to="tr.tracking_url">{{tr.awb}}</router-link></p>
              </vs-td>

              <vs-td style="text-align: center">
                <p class="product-category">RM {{ tr.total_amount.toFixed(2) }}<br>( {{tr.total_qty}} item(s) )</p>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"  class="ml-3" @click.stop="editData(tr)" />
                <feather-icon icon="TruckIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-3" @click.stop="fulfill(tr)" />
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>

    <vs-row vs-type="flex" vs-justify="center" >
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <vs-button v-if="can_load_more" color="primary" type="filled" icon-pack="feather" icon="icon-chevrons-down" @click="loadMore">Load More</vs-button>
        <vs-button v-if="!can_load_more" color="primary" type="filled" icon-pack="feather" icon="icon-refresh-ccw" @click="refreshTable">Refresh</vs-button>
      </vs-col>
    </vs-row>

    <template>
      <vs-popup classContent="popup-example" title="Order Fulfillment" :active.sync="popupFulfillment">
        <div class="vx-col w-full mb-base">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Provider</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <v-select label="provider_name" name="provider_name" v-model="fulfillment.provider" :options="fulfillmentProvider"/>
            </div>
          </div>
        </div>
        <div class="vx-col w-full mb-base" v-if="isEasyParcel">
          <div class="vx-row mb-6">
            <div class="vx-col w-1/3">
              Collection Date
            </div>
            <div class="vx-col w-2/3">
              <flat-pickr :config="configdateTimePicker" v-model="epdata.coll_date" placeholder="Count Down Start" />
            </div>
          </div>
        </div>
        <div class="vx-col w-full mb-base" v-if="showCourier">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Courier</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <v-select label="name" :options="couriers"  v-model="fulfillment.courier" name="courier"/>
            </div>
          </div>
        </div>
        <div class="vx-col w-full mb-base" v-if="showCourier">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>AWB</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" data-vv-validate-on="blur" name="awb"  v-model="fulfillment.awb"/>
            </div>
          </div>
        </div>
        <div class="vx-col w-full mb-base" v-if="showCourier">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Tracking URL</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" data-vv-validate-on="blur" name="url"  v-model="fulfillment.url"/>
            </div>
          </div>
        </div>
        <div class="vx-col w-full mb-base">
          <div class="vx-row mb-0">
            <div class="vx-col sm:w-1/3 w-full">
              <span>&nbsp;</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <div class="vx-col ml-auto mr-auto">
                <vs-button class="mr-3 mb-2" size="large" @click.stop="saveFulfillment">Save</vs-button>
                <vs-button color="warning" type="border" class="mr-3 mb-2" size="large" @click.stop="cancelFulfillment">Cancel</vs-button>
              </div>
            </div>
          </div>
        </div>
      </vs-popup>
    </template>

    <template>
      <vs-popup classContent="popup-example" title="EasyParcel Rates" :active.sync="popupEasyParcelRates">
        <div class="vx-col w-full mb-base">
          <div class="vx-row mb-6">
            <div class="vx-col w-1/3 mt-3">
              Service Type
            </div>
            <div class="vx-col w-2/3">
              <v-select label="label" name="service_type" v-model="selected_service_type" :options="service_types"/>
            </div>
          </div>
        </div>
        <template>
          <vs-table :data="filtered_rates">

            <template slot="thead">
              <vs-th>Service</vs-th>
              <vs-th>Duration</vs-th>
              <vs-th>Price</vs-th>
              <vs-th>Action</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="idx" v-for="(tr, idx) in data">

                <vs-td :data="tr.courier_name">
                  <img v-bind:src=tr.courier_logo style="max-width: 120px" />
                </vs-td>

                <vs-td :data="tr.delivery">
                  {{ tr.delivery }}
                </vs-td>

                <vs-td :data="tr.price">
                  {{ tr.price }}
                </vs-td>
                <vs-td :data="tr.service_id">
                  <vs-button color="primary" type="border" icon-pack="feather" icon="icon-truck" @click="submitEasyparcelOrder(tr)">Order</vs-button>
                </vs-td>
              </vs-tr>
            </template>

          </vs-table>
        </template>
      </vs-popup>
    </template>

  </div>
</template>

<script>
import router from '@/router';
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

const FullfillmentType = [ 'Self', 'EasyParcel', 'Courier'];
const Status = [ 'Canceled', 'Pending', 'Completed' ];

const dialogs = {
  confirmDelete: (ids, callback) => {
    let text, title;

    if (ids.length > 1) {
      title = `Confirm Deletion of ${ids.length} forms`
      text = `Are you sure you want to delete these ${ids.length} forms?`
    } else {
      title = `Confirm Deletion`
      text = `Are you sure you want to delete this form?`
    }

    return {
      type: 'confirm',
      color: 'danger',
      title: title,
      text: text,
      accept: callback
    }
  }
}

const notifs = {
  error: (msg) => {
    return {
      title: 'Error',
      text: msg,
      iconPack: 'feather',
      icon: 'icon-alert-circle',
      color: 'danger'
    }
  },

  success: (msg) => {
    return {
      title: 'Success',
      text: msg,
      iconPack: 'feather',
      icon: 'icon-check-circle',
      color: 'success'
    }
  }
}

const STATUS = [ 'Canceled', 'Pending', 'Paid' ];
const FULFILLMENT = [ 'Self Fulfill', 'EasyParcel', 'Other Courier' ];
const STATUS_COLOR = [ 'danger', 'warning', 'success' ];
const FULFILLMENT_COLOR = [ 'warning', '#FF0089', 'danger' ];

export default {
  data () {
    return {
      selected: [],
      itemsPerPage: 10,
      isMounted: false,

      popupFulfillment: false,

      current_order: {},

      fulfillment: {
        awb: '',
        provider: {},
        courier: {},
        url: ''
      },


      configdateTimePicker: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i'
      },

      epdata: {
        coll_date: new Date(),
        rates: [],
      },

      popupEasyParcelRates: false,

      service_types: [
        {
          label: "Drop Off",
          type: "dropoff",
        }, {
          label: "Pickup",
          type: "pickup",
        }
      ],

      selected_service_type: {
        label: "Pickup",
        type: "pickup",
      },

      // Data Sidebar
    }
  },

  components: {
    'v-select': vSelect,
    flatPickr
  },

  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },

    orders () {
      return this.$store.state.order.orders;
    },

    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.orders.length
    },

    can_load_more () {
      return this.$store.state.order.can_load_more;
    },

    maxItems () {
      if (this.isMounted) {
        return this.$refs.table.maxItems;
      }
      return 0
    },

    fulfillmentProvider () {
      return this.$store.state.fulfillment.organization_providers;
    },

    couriers () {
      return this.$store.state.fulfillment.couriers;
    },

    showCourier () {
      if (!this.fulfillment.provider) return false;
      return this.fulfillment.provider.fullfillment_provider_id === 1;
    },

    isEasyParcel () {
      if (!this.fulfillment.provider) return false;
      let name = this.fulfillment.provider.provider_name;
      if (typeof name === 'undefined') return false;
      return name.toLowerCase().indexOf('easyparcel') > -1;
    },

    filtered_rates () {
      let cur_type = this.selected_service_type.type;
      return this.epdata.rates.filter((x) => {
        return x.service_detail.indexOf(cur_type) > -1;
      });
    },
  },

  methods: {

    handleSearch(search) {
      if (search.length > 3) this.debounceSearch(search);
      if (search.length === 0) {
        this.refreshTable();
      }
    },

    actualSearch(search) {
      this.$store.commit('order/RESET_ORDERS');
      let param = {
        page_length: this.maxItems,
        last_index: this.$store.state.order.last_index,
        search: search
      }


      this.$store.dispatch('order/getOrders', param);
    },

    addNewData() {

    },

    editData(order) {
      this.$router.push(`/orders/${order.id}`);
    },

    getPaymentStatus(status) {
      return STATUS[status];
    },

    getPaymentColor(status) {
      return STATUS_COLOR[status];
    },

    getFulfillmentColor(status) {
      return FULFILLMENT_COLOR[status];
    },

    getFulfillmentStatus(status) {
      return FULFILLMENT[status];
    },

    fulfill(data) {
      if (parseInt(data.status) !== 2) {
        return this.$vs.notify(notifs.error("Cannot fulfill unpaid order"));
      }

      this.current_order        = data;
      this.fulfillment.awb      = data.awb;
      this.fulfillment.url      = data.tracking_url;

      this.fulfillment.provider = {};
      this.fulfillment.courier  = {};

      if (data.organization_fulfillment_provider_id > 0) {
        let idx = _.findIndex(this.fulfillmentProvider, 
          (x) => {
            return x.id == data.organization_fulfillment_provider_id
          }
        );
        if (idx > -1) this.fulfillment.provider = this.fulfillmentProvider[idx];
      }
      
      if (data.courier_name !== '') {
        let idx = _.findIndex(this.couriers, 
          (x) => {
            return x.name === data.courier_name
          }
        );
        if (idx > -1) this.fulfillment.courier = this.couriers[idx];
      }

      this.popupFulfillment = true;
    },

    async saveFulfillment() {
      this.popupFulfillment = false;

      if (this.isEasyParcel) {
        this.epdata.rates = []; // clear previous rates
        this.popupEasyParcelRates = true;
        try {
          this.$vs.loading();
          this.epdata.rates = await this.$store.dispatch('easyparcel/getRates', { 
            order_id: this.current_order.id,
            collection_date: this.epdata.coll_date
          });
        } catch(e) {
          console.log(e);
          this.$vs.notify(notifs.error(e));
        } finally {
          this.$vs.loading.close();
        }

      } else if(this.showCourier) {
        let fulfillment = this.$store.dispatch('order/updateFulfillment', 
          {
            order: _.cloneDeep(this.current_order), 
            fulfillment: _.cloneDeep(this.fulfillment),
          }
        );
      } else {
        this.$vs.notify(notifs.error("Invalid fulfillment"));
      }
    },

    cancelFulfillment() {
      this.fulfillment.awb      = '';
      this.fulfillment.provider = {};
      this.fulfillment.courier  = {};
      this.fulfillment.url      = '';
      this.popupFulfillment = false;
    },

    async submitEasyparcelOrder(tr) {
      this.popupEasyParcelRates = false;
      let params = {
        order_id: this.current_order.id,
        service_id: tr.service_id,
        collection_date: tr.pickup_date,
        organization_fulfillment_provider_id: this.fulfillment.provider.id,
      }

      try {
        this.$vs.loading();
        let fulfillment = await this.$store.dispatch('easyparcel/submitOrder', params);

        this.$store.commit('order/UPDATE_FULFILLMENT', {
          order: this.current_order,
          fulfillment
        });
        this.$vs.notify(notifs.success(`Fulfillment with EasyParcel is succesful. Please prepare for pickup/dropoff.`));
      } catch(e) {
        this.$vs.notify(notifs.error(e));
      } finally {
        this.$vs.loading.close();
      }
    },

    sameServiceType(type) {
      let cur_type = this.selected_service_type.type;
      return type.indexOf(cur_type) > -1;
    },

    formatDate(datestring) {
      const oneday = 86400;
      let now = new Date();
      let the_date = new Date(datestring);

      let diff = Math.floor((now.getTime() - the_date.getTime()) / 1000);

      if (diff >= oneday) {
        const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
        return the_date.toLocaleString('en-MY', options);
      }

      let hours = Math.floor(diff / 3600);

      if (hours === 0) {
        return 'a few minutes ago';
      }

      if (hours === 1) {
        return 'one hour ago';
      }

      return `${hours} hours ago`;
    },

    loadMore() {
      let param = {
        page_length: this.maxItems,
        last_index: this.$store.state.order.last_index
      }

      this.$store.dispatch('order/getOrders', param);
    },

    async refreshTable() {
      await this.$store.commit('order/RESET_ORDERS');
      let param = {
        page_length: this.maxItems,
        last_index: this.$store.state.order.last_index
      }

      this.$store.dispatch('order/getOrders', param);
    }

  },

  created () {
    this.$store.dispatch('order/getOrders', { page_length: this.itemsPerPage });
  },

  async mounted () {
    this.isMounted = true;
    // configure api call limit when typing search
    this.debounceSearch = _.debounce(this.actualSearch, 500);

    let result = await Promise.all([
      this.$store.dispatch('fulfillment/getCouriers'),
      this.$store.dispatch('fulfillment/getOrganizationProvider', this.$store.state.user.current_organization),
      this.$store.dispatch('fulfillment/getProviders')
    ]).then((res)=> {})
      .catch((e) => {
        console.log(e);
      })
  },
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }
  }
}

.con-vs-popup .vs-popup {
  width: 600px !important;
}
</style>
